module.exports = __webpack_public_path__ + "static/img/video-bg.e00e131.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/video-bg.jpg
// module id = FAy6
// module chunks = 1